module.exports = __webpack_public_path__ + "static/img/Philippe-Delorme_2017-18.8be74ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/Philippe-Delorme_2017-18.jpg
// module id = EACY
// module chunks = 0